import { useTranslation } from 'react-i18next';
import { useGetDashBoard } from '../Dashboard/api';
import { useGetProfile } from '../Myprofile/api';

const Activity = (props) => {
    const { data: getProfile } = useGetProfile()
    const { data: getDashboard } = useGetDashBoard()
    const {t} = useTranslation()
    

    return (
        <div className='TrnsctnPg'>
            <div className='row'>
                <div className='col-lg-8'>
                    <div className="TrnsctnDts">
                        <div className="TrnsctnDtsTp">
                            <h4>{t('Activity')}</h4>
                        </div>
                        <div className='table-responsive px-3'>
                            <table className='table' aria-hidden='true'>
                                <thead>
                                    <th>{t('Date & Time')}</th>
                                    <th>{t('Device')}</th>
                                    <th>{t('Location')}</th>
                                    <th>{t('IP Address')}</th>
                                </thead>
                                <tbody>
                                    {
                                        getDashboard?.History.length === 0 ? (
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: 'center' }}>{t('No data found')}</td>
                                            </tr>
                                        ) : (
                                            getDashboard?.History.map((v, i) => (
                                                <tr key={v?.id}>
                                                    <td>{new Date(v.date).toLocaleString()}</td>
                                                    <td>{v.browser_name}</td>
                                                    <td>{v.os_name}</td>
                                                    <td>{v.ip_address}</td>
                                                </tr>
                                            ))
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                   
                </div>
                <div className="col-lg-4 col-md-6 CustPad">
                    <div className='DshbrdPrfl'>
                        <div className='DshbrdPrflTp'>
                            <h4>{t('Welcome')} <span>{getProfile?.data?.userName}    </span></h4>
                        </div>
                        <div className='DshbrdPrflVrfy'>
                            <label>{t('Your Account Status')}</label>
                            <h5>{t('Email Verified')}<img src={require('../../assets/images/tick-circle.svg').default} alt='' /></h5>
                            <div className='mt-2'>
                                <label>{t('Receiving Wallet')}</label>
                                <p>{getProfile?.data?.walletAddress}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Activity;